import { useScrollReveal } from '../../hooks/useScrollReveal';

const ABOUT_RACES = [
  { name: 'Orc', type: 'Offensive', emoji: '\u2694\uFE0F' },
  { name: 'Elf', type: 'Arcane', emoji: '\uD83C\uDFF9' },
  { name: 'Dwarf', type: 'Defensive', emoji: '\uD83D\uDEE1\uFE0F' },
  { name: 'Halfling', type: 'Defensive', emoji: '\uD83C\uDF40' },
];

export function AboutSection() {
  const { ref, isVisible } = useScrollReveal();

  return (
    <section id="about" className="px-6 md:px-12 py-24 max-w-[1200px] mx-auto" ref={ref}>
      <div
        className="grid gap-16 items-center grid-cols-1 xl:grid-cols-2"
        style={{
          opacity: isVisible ? 1 : 0,
          transform: isVisible ? 'translateY(0)' : 'translateY(30px)',
          transition: 'opacity 0.6s ease, transform 0.6s ease',
        }}
      >
        <div>
          <div
            className="mb-3 uppercase tracking-[0.15em]"
            style={{ fontFamily: "'Cinzel', serif", fontSize: 11, fontWeight: 600, color: '#a08030' }}
          >
            What is Galdorn?
          </div>
          <h2
            className="mb-4"
            style={{ fontFamily: "'Cinzel', serif", fontSize: 36, fontWeight: 700, color: '#f0e8dc', lineHeight: 1.2 }}
          >
            A Strategy Game of Cunning &amp; Conquest
          </h2>
          <p className="mb-5" style={{ color: '#f0e8dc', lineHeight: 1.7 }}>
            <span
              style={{
                fontFamily: "'Cinzel', serif",
                fontSize: 52,
                float: 'left',
                lineHeight: 1,
                marginRight: 10,
                marginTop: 6,
                color: '#c8a84e',
              }}
            >
              G
            </span>
            aldorn is a persistent, tick-based kingdom management game. You lead a province within
            a larger kingdom, building your economy, training armies, casting spells, and gathering
            intelligence on your rivals — all in real time.
          </p>
          <p className="mb-5" style={{ color: '#f0e8dc', lineHeight: 1.7 }}>
            But raw military strength alone won&apos;t win the age. Information is the true currency
            of power. Scout enemy defenses before you strike. Sabotage their resources through
            covert operations. Knowledge of your opponent&apos;s weaknesses — and protecting your
            own secrets — is what separates rulers from ruins.
          </p>
          <p style={{ color: '#f0e8dc', lineHeight: 1.7 }}>
            Coordinate with your kingdom mates or go it alone. Every age is a fresh start, every
            decision permanent, every alliance fragile.
          </p>
        </div>

        <div className="grid grid-cols-2 gap-3">
          {ABOUT_RACES.map((race) => (
            <div
              key={race.name}
              className="relative overflow-hidden rounded-md transition-all duration-300 hover:-translate-y-1 hover:border-game-600"
              style={{
                aspectRatio: '3/4',
                background: '#0a0908',
                border: '1px solid #24201b',
              }}
            >
              <div className="absolute inset-0 flex items-center justify-center text-7xl opacity-15">
                {race.emoji}
              </div>
              <div className="absolute inset-0 flex flex-col justify-end p-4">
                <div
                  className="relative z-10"
                  style={{ fontFamily: "'Cinzel', serif", fontSize: 14, fontWeight: 600, color: '#f0e8dc' }}
                >
                  {race.name}
                </div>
                <div
                  className="relative z-10 uppercase tracking-wider"
                  style={{ fontSize: 11, color: '#635850' }}
                >
                  {race.type}
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
